import sanitize, { IOptions } from "sanitize-html";

const options: IOptions = {
  allowedTags: ["p", "strong", "em", "a", "ul", "ol", "li", "br"],
  allowedAttributes: {
    a: ["href", "target", "rel"],
  },
};

export const sanitizeHtml = (value = ""): string | null => {
  // convert string to html
  const htmlObject = document.createElement("div");
  htmlObject.innerHTML = value.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
  const stringValue = htmlObject.innerText;

  // remove empty strings
  const formattedValue = stringValue ? value : null;

  if (formattedValue && formattedValue !== "<p><br></p>") {
    return sanitize(formattedValue, options);
  }

  return null;
};
